/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'house': {
    width: 28,
    height: 22,
    viewBox: '0 0 28 22',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M23.946 22v-9.788L13.714 4.144 3.48 12.212v9.787L11.49 22v-6.897h4.448V22h8.008z" _fill="#fff"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M1.437 12.683l12.276-9.679 12.35 9.738 1.484-1.882-3.654-2.881V.693h-4.707v3.575L13.774 0 0 10.86l1.437 1.823z" _fill="#fff"/>'
  }
})
